import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class MobileNav extends HTMLElement {
  static get observedAttributes() {
    return ['data-display'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-display') {
      const display = newValue === '';
      dispatchEvent('mobilenav:display', { value: display });
      if (display) {
        document.documentElement.setAttribute('data-unscrollable', '');
      } else {
        document.documentElement.removeAttribute('data-unscrollable');
      }
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#setListeners();
  }

  #setListeners() {
    document.addEventListener('topbar:mobilenav', () => {
      this.toggleAttribute('data-display');
    });
  }
}

customElements.define('mobile-nav', MobileNav);
